module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b39c11251b02102b4a748769579793a4.png";